// Cache expiration times for all caching operations are stored here in milliseconds

// Private helpers for generating times in milliseconds from various units
// const minutes = n => n * 60000;
// const hours   = n => n * 3600000;
const days    = n => n * 86400000;


// Generate a cache policy with a given duration
// policy object definition:
// {
//   isStale: function with signature `(timestamp) => boolean` that determines if a `timestamp` is stale based on the policy duration
//            `timestamp` can be falsey, and will be treated as stale.
//   duration: the policy duration in milliseconds
// }

// Generic isStale method. Must be called directly on a policy object, it is not a bound method.
function isStale(timestamp) {
	return !(timestamp && Date.now() - timestamp < this.duration);
}

// Policy factory
function makePolicy(duration) {
	return { isStale, duration };
}



//////////////
// Policies //
//////////////

// How long to cache a single blog post
export const post = makePolicy(days(1));



// WEBPACK FOOTER //
// ./src/helpers/cachePolicies.js